import { HeartFilled, HeartOutlined } from '@ant-design/icons';
import cx from 'classnames';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useCollection } from '@/hooks';

interface CollectProps {
  productCode: API.UserAttentionReq['productCode'];
  collected?: boolean;
  className?: string;
  onChange?: (collected: boolean) => void;
}

const Collect: FC<CollectProps> = ({
  productCode,
  collected: defaultCollected = false,
  className,
  onChange,
}) => {
  const [collected, setCollected] = useState<boolean>(defaultCollected!);

  useEffect(() => {
    setCollected(defaultCollected);
  }, [defaultCollected]);

  const { onSetCollect } = useCollection({
    onSuccess: () => {
      setCollected((pre) => !pre);
      onChange?.(!collected);
    },
  });

  const handleChange: React.MouseEventHandler<HTMLSpanElement> = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onSetCollect({
      operationType: collected ? 2 : 1,
      productCode,
    });
  };

  const CollectIcon = collected ? HeartFilled : HeartOutlined;

  return (
    <CollectIcon
      className={cx('text-18 cursor-pointer', className)}
      onClick={handleChange}
    />
  );
};

export default Collect;
